import { ErrorPage } from '@/pages/Layout/pages';
import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';
import { lazy } from 'react';
import {
  BUSINESS_ROLE_GROUPS,
  EXTERNAL_OPERATOR_ROLE_GROUPS,
} from '@/components/security/AppRoles';

const Services = lazy(() => import('../Services'));
const ViewService = lazy(() => import('../pages/ViewService'));
const EditService = lazy(() => import('../pages/EditService'));
const CreateService = lazy(() => import('../pages/CreateService'));

const ADMIN_PERMISSIONS = [
  ...BUSINESS_ROLE_GROUPS.operations,
  ...EXTERNAL_OPERATOR_ROLE_GROUPS.admin,
];

const ServicesRoutes: RouteObject[] = [
  {
    path: 'logistics-management/services',
    element: (
      <Authorize
        permission={ADMIN_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <Services />
      </Authorize>
    ),
  },
  {
    path: 'logistics-management/service/:id',
    element: (
      <Authorize
        permission={ADMIN_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <ViewService />
      </Authorize>
    ),
  },
  {
    path: 'logistics-management/service/:id/edit',
    element: (
      <Authorize
        permission={ADMIN_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <EditService />
      </Authorize>
    ),
  },
  {
    path: 'logistics-management/services/create',
    element: (
      <Authorize
        permission={ADMIN_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <CreateService />
      </Authorize>
    ),
  },
];

export default ServicesRoutes;
